export function sliceTextWithPoint(el: string | undefined, points: number = 15, amountSlice: number = 5) {
    if (!el) return el;
    if (el.length > points) return el.slice(0, amountSlice) + "..." + el.slice(-amountSlice)
    return el;
}